module.exports = __webpack_public_path__ + "static/media/Close.2b7fa937.svg";